import { Error } from "@Components/common/Error";
import Figure from "@Components/weather-report/figure/Figure";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import { useArticle } from "@Hooks/useArticle";

export const WeatherReportTeaser = () => {
  const { article, error } = useArticle();
  const { t } = useTranslations();
  if (error) {
    return <Error />;
  }

  return (
    <div className="m:flex m:flex-col m:gap-6 m:self-stretch m:text-neutral-white m:hover:text-neutral-white">
      {article?.lead && (
        <blockquote className="m:before:text-white m:after:text-white m:mt-[6px] m:font-serif m:text-[20px] m:leading-normal m:font-light m:tracking-0.4 m:before:content-['«'] m:after:content-['»']">
          <span>&nbsp;{article.lead}&nbsp;</span>
        </blockquote>
      )}
      <div className="m:flex">
        {article?.image && <Figure {...article.image} format="avatar-small" />}
        <p className="m:tracking-tracking-0.4 m:ml-3 m:flex m:flex-col m:justify-center m:gap-[2px] m:text-xl m:leading-[16.1px] m:font-medium m:antialiased">
          {article?.author && <span>{article.author}</span>}
          <span className="m:block m:text-[12px] m:leading-[13.8px] m:font-normal m:text-blue-100 m:dark:text-blue-200">
            {t("businessUnit")}
          </span>
        </p>
      </div>
    </div>
  );
};
